export function roundTwoDecs(number) {
  return Math.round((number + Number.EPSILON) * 100) / 100;
}
